<template>
  <div class="head-operation-wrap">
    <div class="bottom-wrap">
      <div class="bottom-content-wrap">
        <a-row type="flex" justify="center" align="middle">
          <a-col :span="14" class="title-wrap">
            <img src="@/assets/images/headerLogo.png" alt="" />
            <span class="first">{{ projectName }}</span>
          </a-col>
          <a-col :span="5" class="right-wrap">
            <div @click="backStackRoutes('operationIssue')">
              <img :src="demandBgImg" alt="" />
              <span class="textClass">运营发布</span>
            </div>
            <div @click="backStackRoutes('demandIssue')">
              <img :src="operationBgImg" alt="" />
              <span class="textClass">需求发布</span>
            </div>
          </a-col>
          <a-col :span="2">
            <a-dropdown>
              <span @click="(e) => e.preventDefault()" v-if="!isShowLogin">
                {{ accountName }}
                <a-icon type="down" />
              </span>
              <span class="topLogin" v-else>
                <span @click="loginClick">登录</span>
                <span>|</span>
                <span @click="toRegister">注册</span>
              </span>
              <a-menu slot="overlay" v-if="!isShowLogin">
                <a-menu-item
                  v-for="(menu, index) in userMenus"
                  :key="`menu${index}`"
                >
                  <span @click="toPage(menu)">{{ menu.title }}</span>
                </a-menu-item>
                <a-menu-item v-if="role !== 'visitor'">
                  <span @click="exitLogin">退出登录</span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-col>
          <a-col :span="2" v-if="projectKey!== 'SzTech'">
            <a :href="'/static/operation/' + downLink" :download="downLink"
              >操作手册</a
            >
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { sideOptions } from '../../backstageSupport/components/configs'
// import Search from './Search.vue'
// import { userLogout } from '@/api/user'

export default {
  components: {
    // Search,
  },
  data() {
    return {
      sideOptions,
      accountName: '', // 用户名称
      projectName: null,
      demandBgImg: '/static/operation.png',
      operationBgImg: '/static/requestIcon.png',
      downLink: '肇庆市战略性新兴产业集群中小企业转化对接平台操作手册.docx',
    }
  },
  mounted() {
    this.projectName = process.env.VUE_APP_NAME
    let key = process.env.VUE_APP_KEY
    switch (key) {
      case 'Hy': // 河源
        this.demandBgImg = require('@/assets/images/HyImg/需求发布.png')
        this.operationBgImg = require('@/assets/images/HyImg/运营发布.png')
        this.downLink =
          '河源市战略性新兴产业集群中小企业转化对接平台操作手册.docx'
        break
      case 'Mz': // 梅州
        this.demandBgImg = require('@/assets/images/MzImg/需求发布.png')
        this.operationBgImg = require('@/assets/images/MzImg/运营发布.png')
        this.downLink =
          '梅州市沿海经济带和粤北生态发展区涉农专利转化对接平台操作手册.docx'
        break
      case 'Yj': // 阳江
        this.downLink =
          '阳江市战略性新兴产业集群中小企业转化对接平台操作手册.docx'
        break
      case 'Mm': // 茂名
        this.downLink =
          '茂名市战略性新兴产业集群中小企业转化对接平台操作手册.docx'
        break
    }
  },
  watch: {
    userName: {
      handler(val) {
        if (!val) return
        this.accountName = val
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters('user', ['account', 'role', 'userName']),
    isShowLogin() {
      if (this.account === '游客' || this.account === '') {
        return true
      }
      return false
    },
    userMenus() {
      let list = []
      const userList = [
        '账户信息',
        '开放许可管理',
        '需求管理',
        '运营管理',
        '服务机构',
        '收藏管理',
      ]
      switch (this.role) {
        case 'admin':
        case 'bus':
          this.sideOptions.forEach((option) => {
            list.push({
              title: option.title,
              ...option.child[0],
            })
          })
          break
        case 'user':
          this.sideOptions.forEach((option) => {
            if (userList.indexOf(option.title) >= 0) {
              let item = option.child[0]
              list.push({
                title: option.title,
                ...item,
              })
            }
          })
          break
        default:
          list = []
          break
      }
      return list
    },
    projectKey() {
      return process.env.VUE_APP_KEY
    }
  },
  methods: {
    // 页面跳转
    toPage(item) {
      this.$router.push({
        path: item.toRouter,
        query: { key: item.key },
      })
    },
    // 登录
    loginClick() {
      this.$router.push({
        path: '/login',
        query: {
          redirect: this.$route.path,
        },
      })
    },
    toRegister() {
      this.$router.push({
        path: '/login',
        query: { toComponent: 'register' },
      })
    },
    async exitLogin() {
      // const header = getHeaders()
      // const { status, data } = await userLogout(header)
      // if (status === 1) {
      // this.$apiStatusHandler(0, data, 0.5)
      this.$store.dispatch('user/clearAccountInfo')
      this.$router.push({ path: '/login' })
      // }
    },
    // 运营发布
    backStackRoutes(key) {
      if (this.account && this.account !== '游客') {
        this.$router.push({ name: key, query: { key } })
      } else {
        const page = this.getPath(key)
        this.$router.push({
          path: '/login',
          query: {
            redirect: page.toRouter,
            key,
          },
        })
      }
    },
    // 通过key获取页面路由信息
    getPath(key) {
      for (let i = 0; i < this.sideOptions.length; i++) {
        const option = this.sideOptions[i]
        for (let j = 0; j < option.child.length; j++) {
          const element = option.child[j]
          if (element.key === key) {
            return element
          }
        }
      }
      return {
        toRouter: '',
        key,
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
